// Mirrors views/Members/Join/columns.js (same picker shape: checkbox + First/Last Name +
// Membership No. + Zone) — column keys double as backend sort keys (UserFilters::LIST_SORTABLE).
// 'select' and 'member_number' are not sortable, matching the legacy DataTable definition for
// this page.
export function buildColumns() {
  return [
    { key: 'select', label: '', minWidth: '40px', width: '0.3fr' },
    { key: 'first_name', label: 'First Name', sortable: true, minWidth: '100px', width: '1.4fr' },
    { key: 'last_name', label: 'Last Name', sortable: true, minWidth: '130px', width: '2fr' },
    { key: 'member_number', label: 'Membership No.', minWidth: '110px', width: '1.6fr' },
    { key: 'zone_id', label: 'Zone', sortable: true, minWidth: '60px', width: '0.7fr' }
  ]
}

// Below 700px: checkbox + combined name always visible, same treatment as Join's columns.js.
export function buildBreakpoints() {
  return [
    {
      maxWidth: 700,
      hideHeader: true,
      accordion: {
        summary: [
          { keys: ['select'], hideLabel: true },
          { keys: ['name'], hideLabel: true }
        ]
      },
      rows: [
        ['member_number'],
        ['zone_id']
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/Members/Merge/columns.js